import styled from "styled-components";

const Description = styled.p`
  text-align: left;
  color: var(--app-color-text, #393939);
  margin: 0 0 0 0;
`

export default Description;